import React, { FC, useRef } from 'react';
import s from 'src/pages/signup-page/signup-page.module.scss';
import { Formik } from 'formik';
import AuthForm from 'src/features/forms/auth-form/auth-form';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { useNavigate } from 'react-router-dom';
import { selectAuthErrorMessages, signup } from 'src/features/auth/auth-slice';
import { initialAuthFormValues, signupFormValidate } from 'src/features/forms/forms-consts';

const SignupPage: FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const formElementRef = useRef<HTMLFormElement>(null);
  const autoFocusElementRef = useRef(null);

  const authErrorMessages = useAppSelector(selectAuthErrorMessages);

  return (
    <main>
      <div className={s.welcomeText}>
        <div className={s.welcomeTextContainer}>
          <h2>{t('screens.home.signup')}</h2>
          <Formik
            initialValues={initialAuthFormValues}
            validate={signupFormValidate}
            onSubmit={(formData) => {
              dispatch(signup({ data: formData, navigate }));
            }}
          >
            {(formik) => (
              <AuthForm
                formManager={formik}
                formElement={formElementRef}
                autoFocusElement={autoFocusElementRef}
                withPasswordConfirmation
              />
            )}
          </Formik>
          {!!authErrorMessages.length && (
            <div className={s.error}>
              {authErrorMessages.map((msg) => (
                <div key={msg}>{msg}</div>
              ))}
            </div>
          )}
        </div>
      </div>
    </main>
  );
};

export default SignupPage;
